export async function createFollowUpEvent(
  accessToken: string,
  leadName: string,
  companyName: string,
  followUpDate: string,
  ownerEmail?: string,
  notes?: string
) {
  if (!accessToken) throw new Error("No Google Access Token available");

  // Set default time to 9:00 AM local time on the follow-up date
  const [year, month, day] = followUpDate.split('-').map(Number);
  const localStartDate = new Date(year, month - 1, day, 8, 0, 0, 0);
  const localEndDate = new Date(year, month - 1, day, 9, 0, 0, 0);

  const event: any = {
    summary: `Follow up: ${leadName || 'Contact'} - ${companyName}`,
    description: `CRM Follow-up Reminder for ${companyName}.${notes ? `\n\nOutreach Notes:\n${notes}` : ''}`,
    transparency: 'transparent', // Mark as "Free" on calendar so it doesn't block time
    reminders: {
      useDefault: false,
      overrides: [
        { method: 'popup', minutes: 15 },
        { method: 'email', minutes: 60 }
      ]
    },
    start: {
      dateTime: localStartDate.toISOString(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    end: {
      dateTime: localEndDate.toISOString(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  };

  // If an owner email is specified, add them as an attendee
  if (ownerEmail) {
    event.attendees = [{ email: ownerEmail }];
  }

  const response = await fetch("https://www.googleapis.com/calendar/v3/calendars/primary/events?sendUpdates=all", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(event),
  });

  if (!response.ok) {
    const errText = await response.text();
    throw new Error(`Failed to create Calendar event: ${response.status} ${errText}`);
  }

  return await response.json();
}
